module.exports = __webpack_public_path__ + "4c005eb72a39bbe2b32b67bb28be7427.svg";